<section class="flex flex-col items-center gap-12">
  <app-section-header
    [icon]="'@tui.shield-check'"
    [subtitle]="'Promises'"
    [title]="'No surprises with our pricing'"
    [description]="
      'We stand by our pricing with these promises that ensures you get the best value without any surprises.'
    "
  >
  </app-section-header>
  <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.lock" class="mr-2" />
        <h3 class="text-xl font-bold">Price Lock Guarantee</h3>
      </div>
      <p class="text-pretty text-lg">
        Your current plan price will never increase, no matter how long you stay
        with us. Once you're on a plan, that price is yours forever.
      </p>
    </div>
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.eye" class="mr-2" />
        <h3 class="text-xl font-bold">No Hidden Fees</h3>
      </div>
      <p class="text-pretty text-lg">
        What you see is what you pay. No setup fees, no surprise charges, no
        hidden costs. Just transparent, honest pricing you can trust.
      </p>
    </div>
  </div>
</section>
